import { Box, Card, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import useStyles from "./ProgressSummary.styles";
import { colors } from "../../tokens";

const statusProperties = {
	"Novos pedidos": { path: "/new-orders", color: "#12CD0B" },
	"Em separação": { path: "/picking", color: "#00CBFF" },
	"Pronto para retirada": { path: "/ready-to-go", color: "#FFAA00" },
	"Saiu para entrega": { path: "/shipping", color: "#CE00FF" },
	"Retornar para estoque": { path: "/returning-to-storage", color: "#B72F2C" },
};

export default function ProgressSummary({ data }) {
	const classes = useStyles();

	const history = useHistory();

	return (
		<Card className={classes.progressCard}>
			<Box className={classes.sectionHeader}>
				<Typography className={classes.sectionTitle}>{data?.title}</Typography>
				<Typography className={classes.sectionTotal}>{data?.total}</Typography>
			</Box>
			{data?.items.map((item) => {
				const percentage = (item.value * 100) / data.total;
				const isPercentageNaN = Number.isNaN(percentage);

				return (
					<Box className={classes.progressRow} key={item.label} onClick={() => history.push(statusProperties[item.label].path)}>
						<Typography className={classes.progressLabel}>
							{item.label}
						</Typography>
						<Tooltip
							title={item.percentage}
							arrow
							classes={{
								tooltip: classes.percentTooltip,
								arrow: classes.percentTooltipArrow,
							}}
							placement="top"
						>
							<Box className={classes.progressTrack}>
								<Box
									className={classes.progressFill}
									style={{
										width: `${isPercentageNaN ? 0 : percentage}%`,
										backgroundColor: colors.bars[item.color] || statusProperties[item.label].color,
									}}
								/>
							</Box>
						</Tooltip>
						<Typography className={classes.progressCount}>
							{item.value}
						</Typography>
					</Box>
				);
			})}
		</Card>
	);
}
